import { useEffect, useState, useCallback } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAtualizaDadosOs = ({ dadosOs, formik }) => {
  const { request: consultaFormRequest, data: consultaFormData } = useApiClient();
  const { request: requestOcorrencia, data: dataOcorrencia } = useApiClient();
  const [ocorrencia, setOcorrencia] = useState({});

  const { setFieldValue } = formik;

  const carregarOcorrencia = useCallback(
    (seq) => {
      consultaFormRequest(apiRoutes.fiscalizacao.ordemservico.consultaDadosOs, { sequencial: seq });
    },
    [consultaFormRequest],
  );

  useEffect(() => {
    if (consultaFormData) {
      const indice = consultaFormData.result.ocorrencias.length - 1;

      requestOcorrencia(apiRoutes.fiscalizacao.ocorrencia.consultarOcorrencia, {
        sqAcaoFiscal: dadosOs.acaoFiscal,
        sqItemOcorrencia: consultaFormData.result.ocorrencias[indice].sequencial,
      });
    }
  }, [consultaFormData, dadosOs.acaoFiscal, requestOcorrencia]);

  useEffect(() => {
    if (dataOcorrencia) {
      setOcorrencia(dataOcorrencia.result);
      setFieldValue("sqItemOcorrencia", dataOcorrencia.result[0].sqItemOcorrencia);
      setFieldValue("sqItem", 0);
    }
  }, [setOcorrencia, dataOcorrencia, setFieldValue]);

  return { carregarOcorrencia, ocorrencia };
};

export default useAtualizaDadosOs;
